var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9563 16.2288H1.70572V1.791H7.68772V6.273H11.9563V7.1874H13.7143V5.4L11.9571 3.5532L10.2771 1.791L8.57143 0H1.71429C1.26091 0.00166814 0.826677 0.192133 0.506891 0.529595C0.187106 0.867057 0.00788949 1.32395 0.00857337 1.8L1.95007e-06 16.2C-0.00068193 16.6761 0.178534 17.1329 0.49832 17.4704C0.818106 17.8079 1.25234 17.9983 1.70572 18H13.7143V16.2L11.9563 16.2288Z",
    fill: "#125C56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 14.4L18.0001 9H16.7144L15.8572 12.087L15.0001 9H13.7144L15.2144 14.4H16.5001Z",
    fill: "#125C56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85728 9H4.28585C4.05873 9.00071 3.84111 9.09576 3.68051 9.26439C3.51991 9.43302 3.42939 9.66152 3.42871 9.9V13.5C3.42939 13.7385 3.51991 13.967 3.68051 14.1356C3.84111 14.3042 4.05873 14.3993 4.28585 14.4H6.85728C7.0844 14.3993 7.30203 14.3042 7.46262 14.1356C7.62322 13.967 7.71375 13.7385 7.71442 13.5V12.6H6.42871V13.05H4.71443V10.35H6.42871V10.8H7.71442V9.9C7.71375 9.66152 7.62322 9.43302 7.46262 9.26439C7.30203 9.09576 7.0844 9.00071 6.85728 9Z",
    fill: "#125C56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.857 10.3554V9H9.42843C9.2011 9 8.98309 9.09482 8.82234 9.2636C8.6616 9.43239 8.57129 9.66131 8.57129 9.9V11.4813C8.57129 11.72 8.6616 11.9489 8.82234 12.1177C8.98309 12.2865 9.2011 12.3813 9.42843 12.3813H11.5799V13.05H8.57129V14.4063H11.9999C12.2272 14.4063 12.4452 14.3115 12.606 14.1427C12.7667 13.9739 12.857 13.745 12.857 13.5063V11.925C12.857 11.6863 12.7667 11.4574 12.606 11.2886C12.4452 11.1198 12.2272 11.025 11.9999 11.025H9.84843V10.3563L12.857 10.3554Z",
    fill: "#125C56"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCsv);
export default __webpack_public_path__ + "static/media/document-csv.345d069599222d686bf5238366146ba4.svg";
export { ForwardRef as ReactComponent };